export function LoadingPage() {
  return (
    <div className="container px-5 mx-auto flex justify-center items-center">
      <div className=" 
      h-12 
      w-12 
      border-4 
      border-l-gray-900 
      border-r-gray-900 
      border-b-gray-900
      border-t-primary
      animate-spin
      ease-linear
      rounded-full
    " />
    </div>
  );
}